import React from 'react';
import { useParams, Redirect } from 'react-router-dom';
import usePlansFlags from 'screens/Plans/redesign/hooks/usePlansFlags';
import PlanRouteAdmin from 'screens/Plans/redesign/PlanRouteAdmin';
import { paths } from 'routes/paths';

/**
 * Guards the new create/edit routes: renders the wizard when the flag is
 * on, otherwise redirects to the legacy route (mirrors `PlanViewGuard`,
 * inverted). The legacy design never links into `/create` (both callers of
 * that route gate on `fePlansActive`), so the only legacy case here is
 * `/:id/edit`.
 */
const PlanFormRouteGuard: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { fePlansActive } = usePlansFlags();

  if (fePlansActive) {
    return <PlanRouteAdmin />;
  }

  if (id) {
    return (
      <Redirect
        to={{
          pathname: `${paths.plans}/${id}`,
          state: { selectedView: 'edit-fromView' }
        }}
      />
    );
  }

  return null;
};

export default PlanFormRouteGuard;
